// AI-ASSISTED: generated with claude-code on 2026-06-03, reviewed by Yoann Hertienne
import useAsync from 'react-use/lib/useAsync';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { ComponentTile } from './ComponentTile';

export const TeamLanding = () => {
  const { entity } = useEntity();
  const catalogApi = useApi(catalogApiRef);

  const ownedRefs = (entity.relations ?? [])
    .filter(r => r.type === 'ownerOf')
    .map(r => r.targetRef);

  const { value, loading, error } = useAsync(async () => {
    if (ownedRefs.length === 0) return [] as Entity[];
    const res = await catalogApi.getEntitiesByRefs({ entityRefs: ownedRefs });
    return res.items.filter((e): e is Entity => Boolean(e));
  }, [stringifyEntityRef(entity)]);

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4 }} role="alert">
        <Typography color="error">Failed to load team components: {error.message}</Typography>
      </Box>
    );
  }

  const components = (value ?? []).filter(e => e.kind === 'Component');

  if (components.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6">No components owned by this team yet.</Typography>
        <Typography variant="body2" color="text.secondary">
          Add a `catalog-info.yaml` to a repo and set `spec.owner` to this team.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {components.map(c => (
          <Grid key={stringifyEntityRef(c)} item xs={12} sm={6} md={4} lg={3}>
            <ComponentTile component={c} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
